import React, { useEffect } from 'react';
import Header from '../components/Header';
import Banner from '../components/Banner';
import SpecialOffers from '../components/SpecialOffers';
import LatestProducts from '../components/products/LatestProducts';
import FeatureProducts from '../components/products/FeatureProducts';
import Footer from '../components/Footer';
import { useDispatch, useSelector } from 'react-redux';
import { get_products } from '../store/reducers/homeReducer';
import MidBanner from '../components/MidBanner';

const Home = () => {
    const dispatch = useDispatch();
    const { products, discount_product } = useSelector(state => state.home);

    useEffect(() => {
        dispatch(get_products());
    }, []);

    return (
        <div className='w-full bg-[#f5f5f5]'>
            <Header />
            <Banner />

            <div className='bg-white'>
                <SpecialOffers />
            </div>

            <LatestProducts products={discount_product} />

            <div className='pt-4 bg-white mt-2'>
                <FeatureProducts products={products} />
            </div>

            <MidBanner />

            <Footer />
        </div>
    );
};

export default Home;
